import { CheckIcon } from "@heroicons/react/24/outline";
import Image from "next/image";
import React from "react";
import "./Loading.css";

const LoadingCompleteIllustration = () => {
  return (
    <div className="">
      <div className="relative flex h-[90px] w-[90px] items-center justify-center rounded-full bg-[#4A33ED]">
        <Image
          src="/assets/resumeScore/star-top-right.png"
          alt="Complete"
          width={20}
          height={20}
          className="animate-slide-top-right absolute z-10"
        />
        <CheckIcon className="z-20 h-12 w-12 text-white" />
        <Image
          src="/assets/resumeScore/star-bottom-left.png"
          alt="Complete"
          width={43}
          height={43}
          className="animate-slide-bottom-left absolute z-10"
        />
      </div>
    </div>
  );
};

export default LoadingCompleteIllustration;
